module.exports = __webpack_public_path__ + "assets/images/template/project/surgical-mask/mobile.svg?v=3470d085";